import { environment } from 'src/environments/environment';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';
import RepositoryDirective from 'src/smoothr-web-app-core/directives/repository-directive';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';
import { AppComponent } from '../../app.component';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { sleep } from '../../../smoothr-web-app-core/utils/utils';
import Table from '../../../smoothr-web-app-core/models/Table';
import { Api } from '../../../smoothr-web-app-core/api/api';
import { TranslateService } from '@ngx-translate/core';
import { BarcodeFormat } from '@zxing/library';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';
import { MenuPage } from 'src/app/pages/menu/menu.page';
import { url } from 'inspector';

@Component({
	selector: 'app-scan-qr',
	templateUrl: './scan-qr.component.html',
	styleUrls: ['./scan-qr.component.scss'],
})
export class ScanQrModal implements OnInit {
	allowedFormats = [BarcodeFormat.QR_CODE, BarcodeFormat.DATA_MATRIX, BarcodeFormat.AZTEC];
	scannedResult: string | null = null;
	hasDevices = false;
	availableDevices: MediaDeviceInfo[] = [];
	selectedDevice: MediaDeviceInfo | undefined;
	@Input() name!: string;

	// scanning = true;
	// loading = false;
	venue: Venue;

	constructor(
		protected repository: RepositoryService,
		private snackBarCtrl: MatSnackBar,
		private router: Router,
		private modalCtrl: ModalController,
		public translate: TranslateService
	) {}

	/**
	 * returns table number
	 */
	static async show(modalCtrl: ModalController, name?: string): Promise<Table> {
		const resultScan = await modalCtrl.create({
			component: ScanQrModal,
			cssClass: name ? 'item-modal qr-code-scan eintracht' : 'item-modal qr-code-scan',
			componentProps: { name },
		});
		await resultScan.present();
		const res = (await resultScan.onDidDismiss()).data;
		await sleep(100);
		return res;
	}
	ngOnInit() {}
	// close() {
	// 	this.modalCtrl.dismiss();
	// }

	// startScanning() {
	// 	this.scanning = true;
	// }

	// stopScanning() {
	// 	this.scanning = false;
	// }

	// scanSuccessHandler($event: any) {
	// 	this.loading = true;

	// 	this.stopScanning();
	// 	try {
	// 		console.log($event);
	// 		console.log(environment.webAppUrl + '/scan-qr/table/');

	// 		this.takeOverOrder($event.substring($event.lastIndexOf('/') + 1));
	// 	} catch (e) {
	// 		this.loading = false;
	// 		this.snackBarCtrl.dismiss();
	// 		this.snackBarCtrl.open('Bitte QR-Code überprüfen', null, {
	// 			duration: 2000
	// 		});
	// 	}
	// }

	// async takeOverOrder(tableNumber: string) {
	// 	console.log(tableNumber);
	// 	if (tableNumber == null) {
	// 		this.loading = false;
	// 		this.snackBarCtrl.dismiss();
	// 		this.snackBarCtrl.open('Bitte QR-Code überprüfen', null, {
	// 			duration: 2000
	// 		});
	// 		return;
	// 	}
	// 	try {
	// 		await sleep(100);

	// 		const table = (await Api.getTable(this.venue?._id, tableNumber)).data;
	// 		console.log(tableNumber);
	// 		await sleep(100);
	// 		await this.modalCtrl.dismiss(table);
	// 	} catch (e) {
	// 		console.log(e);
	// 		this.snackBarCtrl.dismiss();
	// 		this.snackBarCtrl.open('Fehler beim Abrufen des Tisches: ' + e, null, {
	// 			duration: 2000
	// 		});
	// 		this.modalCtrl.dismiss();
	// 	}
	// 	this.loading = false;
	// }

	async selectVenue(venueId: string, type: PreorderType = PreorderType.TAKE_AWAY) {
		const loadedVenue = await this.repository.getVenue(venueId);
		// console.log(loadedVenue);
		// await sleep(100);
		this.repository.createOrder(loadedVenue, null, OrderType.PREORDER, type);
		// await sleep(100);

		if (type === PreorderType.TAKE_AWAY) {
			await MenuPage.navigate(this.router, this.name);
		}
	}

	async onCodeResult(result: string) {
		this.scannedResult = result;
		const urlObj = new URL(result);
		this.name = urlObj.searchParams.get('name');
		urlObj.search = '';
		result = urlObj.toString();
		const venueId = result.substring(result.lastIndexOf('/') + 1);
		await sleep(100);
		this.modalCtrl.dismiss().then(() => {
			this.selectVenue(venueId, PreorderType.TAKE_AWAY);
		});
	}

	onDeviceSelectChange(event: Event) {
		const target = event.target as HTMLSelectElement; // Fix: Properly typecast EventTarget
		this.selectedDevice = this.availableDevices.find(device => device.deviceId === target.value);
	}

	onHasDevices(hasDevices: boolean) {
		this.hasDevices = hasDevices;
	}

	onDevicesFound(devices: MediaDeviceInfo[]) {
		this.availableDevices = devices;
		if (devices.length > 0) {
			this.selectedDevice = devices[0]; // Fix: Ensure a device is selected initially
		}
	}

	onError(error: any) {
		console.error('Barcode scanning error:', error);
	}
}
